import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const GET_REPORT_BOARD = "getReportBoard";
const REPORTS_LIST = "reportsList";
const CREATE_REPORT_BOARD = "createReportBoard";
const AVAILABLE_GROUPS = "availableGroups";
const SAVE_DEFAULT_FILTER = "saveDefaultFilter";
const GET_REPORT_TEMPLATES = "getReportTemplates";
const DUPLICATE_REPORT = "duplicateReport";

export const reportsKeys = createKeys(featureKeys.REPORTS, {
  getReportBoard: ({ boardID }) => [GET_REPORT_BOARD, boardID?.toString()],
  getReportsList: () => [REPORTS_LIST],
  createReportBoard: () => [CREATE_REPORT_BOARD],
  getAvailableGroups: () => [AVAILABLE_GROUPS],
  saveDefaultFilter: ({ boardID }) => [SAVE_DEFAULT_FILTER, boardID],
  getReportTemplates: () => [GET_REPORT_TEMPLATES],
  duplicateReport: () => [DUPLICATE_REPORT],
});
